/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Close_Aria_LabelInputs */

const en_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close offline activation modal`)
};

const fr_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boite de dialogue d'activation hors ligne`)
};

const de_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-Aktivierungsmodal schließen`)
};

const it_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la modalità di attivazione offline`)
};

const ru_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно активации в автономном режиме`)
};

const es_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el modo de activación sin conexión`)
};

const zh_cn2_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭离线激活模式`)
};

const ja_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインアクティベーションモーダルを閉じる`)
};

const hi_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़लाइन सक्रियण मॉडल बंद करें`)
};

const pt_pt2_offline_activation_close_aria_label = /** @type {(inputs: Offline_Activation_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal de ativação offline`)
};

/**
* | output |
* | --- |
* | "Close offline activation modal" |
*
* @param {Offline_Activation_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_close_aria_label = /** @type {((inputs?: Offline_Activation_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_close_aria_label(inputs)
	if (locale === "de") return de_offline_activation_close_aria_label(inputs)
	if (locale === "it") return it_offline_activation_close_aria_label(inputs)
	if (locale === "ru") return ru_offline_activation_close_aria_label(inputs)
	if (locale === "es") return es_offline_activation_close_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_close_aria_label(inputs)
	if (locale === "ja") return ja_offline_activation_close_aria_label(inputs)
	if (locale === "hi") return hi_offline_activation_close_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_close_aria_label(inputs)
	return en_offline_activation_close_aria_label(inputs)
});